import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import Slider from "react-slick";

const DEFAULT_BANNERS = [
    { path: "https://ae-sexy.bet/media/cache/strip/202206/block/ca71c3e3866365104315e7b17105cd64.jpg", link: "/promotions" },
    { path: "https://ae-sexy.bet/media/cache/strip/202206/block/264d59e38683bd3837e7d5b1e6939f05.jpg", link: "/promotions" },
    { path: "https://ae-sexy.bet/media/cache/strip/202206/block/9dd7f1df795254b4578bbed0f0e32d73.jpg", link: "/promotions" },
];

const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    pauseOnHover: false,
    focusOnSelect: true,
    responsive: [
        { breakpoint: 768, settings: { centerMode: false, variableWidth: false } },
    ],
};

class App extends Component {
    constructor(props) {
        super(props);
        this.state = { tabbannerlist: [] };
    }
    componentDidMount() {
        const cacheKey = "tabBannerListCache_" + Systems;
        const cacheTTL = 3 * 60 * 60 * 1000;
        let cached = null;
        try { cached = JSON.parse(localStorage.getItem(cacheKey)); } catch (e) { cached = null; }
        if (cached && Array.isArray(cached.data) && cached.data.length > 0 && (Date.now() - cached.timestamp < cacheTTL)) {
            this.setState({ tabbannerlist: cached.data });
        } else {
            instance.get("/api/v1/tabbannerlist?System=" + Systems)
                .then((res) => {
                    if (res.data.status === 200 && Array.isArray(res.data.message) && res.data.message.length > 0) {
                        this.setState({ tabbannerlist: res.data.message });
                        localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: res.data.message }));
                    }
                }).catch((err) => { console.error("Error fetching tabbannerlist:", err); });
        }
    }
    render() {
        const { tabbannerlist } = this.state;
        const banners = (tabbannerlist && tabbannerlist.length > 0) ? tabbannerlist : DEFAULT_BANNERS;
        const imgStyle = { width: "650px", height: "234px", maxWidth: "92vw", objectFit: "fill", borderRadius: "15px", display: "block" };
        return (
            <div className="-banner-wrapper">
                <Slider {...settings} className="x-banner-slide-wrapper -single">
                    {banners.map((item, index) => (
                        <div className="-slide-inner-wrapper -slick-item" key={index} style={{ width: "650px", maxWidth: "92vw" }}>
                            <a href={item.link || "/promotions"} className="-link-wrapper">
                                <img src={item.path} alt={"banner " + index} className="img-fluid -slick-item" style={imgStyle} />
                            </a>
                        </div>
                    ))}
                </Slider>
            </div>
        );
    }
}
export default App;
